export default function SPicture({ size = 20, className = "", ...props }) {
    return (
        <svg
            width={size}
            height={size}
            viewBox="1.5 3 17 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
            {...props}
        >
            <path
                d="M11.5625 1.6665H5.3125C4.88281 1.6665 4.51562 1.83317 4.21094 2.15817C3.90625 2.48317 3.75 2.87484 3.75 3.33317V16.6665C3.75 17.1248 3.90625 17.5165 4.21094 17.8415C4.51562 18.1665 4.88281 18.3332 5.3125 18.3332H14.6875C15.1172 18.3332 15.4844 18.1665 15.7891 17.8415C16.0938 17.5165 16.25 17.1248 16.25 16.6665V6.6665L11.5625 1.6665ZM5.4375 15.4165L7.71875 12.1665L9.42969 14.5998L11.7109 11.3498L14.5625 15.4082H5.4375V15.4165ZM10.7812 7.49984V3.33317L14.6875 7.49984H10.7812Z"
                fill="currentColor"
            />
        </svg>

    )
}